// Single source of truth for the back-end base URL.
//
// Create React App inlines REACT_APP_* at build time, so this is fixed when the
// bundle is built (see the build arg in the Dockerfile). For local development
// against a back-end on this machine, put
//   REACT_APP_API_BASE_URL=http://localhost:8080
// in top-cat-ui/.env.dev and run `npm run start:dev`.
export const API_BASE_URL =
    process.env.REACT_APP_API_BASE_URL || "https://api.topcatapp.com";
